import { Component, OnInit, Inject } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { UserService } from '../../../../shared/services/user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-frame-config-warning',
  templateUrl: './frame-config-warning.component.html',
  styleUrls: ['./frame-config-warning.component.scss']
})
export class FrameConfigWarningComponent implements OnInit {
  frameFlagged:number;
  inspectionId:number;
  constructor(private _dialogRef: MatDialogRef<FrameConfigWarningComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _user: UserService) { }

  ngOnInit() {
    this.inspectionId = this._data.inspectionId;
  }
  onNoClick(): void {
    this._dialogRef.close(false);
  }

  FrameFlagChange(event:any){
    this.frameFlagged= event.value;
  }

  ChangeFlag(){
    if(this.frameFlagged>0){
      this._interp.UpdateTrackFrameFlag(this.inspectionId).subscribe(res=>{
        if(res==true){
          this._dialogRef.close(true);
          this._notify.success('Saved','Update Track Frame Configuration Flag.');
        }else{
          this._notify.error('Error','Unable to update Track Frame Configuration Flag.');
        }
      })
    }else{

    }
  }
}
